import React from "react";
import { format } from 'date-fns';
import { formatUTCTimestampToLocal } from "../../../utils/set-date-range-utils";
import Heading from "../../../components/shared/heading";

const JobDetails = ({ job, jobId }) => {

    console.log(job)

    return (
        <div className="flex items-start gap-4">
            <div className="flex flex-col gap-1">



                {job ? (
                    <>
                        {/* Line 1: Job Name */}
                        <Heading>
                            {job.name}
                        </Heading>

                        {/* Line 2: Type, location, time, status */}
                        <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
                            <span>{job.type}</span>
                            <span>•</span>
                            <span>{job.location}</span>
                            <span>•</span>
                            <span>
                                {formatUTCTimestampToLocal(job.startTime, 'yyyy-MM-dd hh:mm a')} - {formatUTCTimestampToLocal(job.endTime, 'yyyy-MM-dd hh:mm a')}
                            </span>
                            <span>•</span>
                            <span className={`px-2 py-0.5 rounded-md border font-medium capitalize
                        ${job.status === "active"
                                    ? "bg-green-100 text-green-700 border-green-600"
                                    : job.status === "inactive"
                                        ? "bg-red-100 text-red-700 border-red-600"
                                        : "bg-yellow-100 text-yellow-700 border-yellow-500"
                                }`}>
                                {job.status}
                            </span>
                        </div>
                    </>
                ) : (
                    <div className="text-red-600">Vehicle with ID {jobId} not found.</div>
                )}
            </div>
        </div>
    );
};

export default JobDetails;